import type { JsonExchange } from './types';

/**
 * Synthetic exchange id representing the DEX pseudo-exchange. The single source of truth for
 * the id: consumers that branch on "is this the DEX option?" must compare against this
 * constant, so the appended option and those checks cannot drift apart.
 */
export const DEX_EXCHANGE_ID = 1001;

/**
 * Autocomplete option shape, structurally compatible with Ant Design's `Select`
 * `options` entries (`{ value, label }`).
 */
export interface ExchangeOption {
  value: number;
  label: string;
}

/**
 * Maps the exchanges list to autocomplete options and appends the synthetic
 * `DEX` option when it is missing. Pure helper — callers wrap it in a
 * `createSelector` for memoization.
 */
export const toExchangeOptions = (items: JsonExchange[]): ExchangeOption[] => {
  const exchangeOptions: ExchangeOption[] = items.map((exchange) => ({
    value: exchange.id,
    label: exchange.name,
  }));

  if (exchangeOptions.some((option) => option.value === DEX_EXCHANGE_ID)) {
    return exchangeOptions;
  }

  return [...exchangeOptions, { value: DEX_EXCHANGE_ID, label: 'DEX' }];
};
